import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, HelpIcon, Page } from '@dixa/lib-shared-habla';
import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { SurveysTable } from '../components/surveysTable';
import { SurveyAddModal } from '../survey/components/add/surveyAddModal';
import { PhoneSurveysTable } from './components/table/phoneSurveysTable';
export const SatisfactionPhoneView = () => {
    const dispatch = useAppDispatch();
    /** Handles the facebook authentication. */
    const openAddSurveyModal = () => {
        dispatch(appActions.showModal({
            modal: {
                type: 'settings:addSurvey',
            },
        }));
    };
    return (_jsxs(_Fragment, { children: [_jsx(Page.Section, Object.assign({ title: "CSAT survey", titleMeta: _jsx(HelpIcon, { text: "Create and edit the surveys that will be used at the end of\n              phone calls.", dark: true }), controls: _jsx(Button, Object.assign({ variant: "primary", onClick: openAddSurveyModal }, { children: "Add survey" })) }, { children: _jsx(SurveysTable, {}) })), _jsx(Page.Section, Object.assign({ title: "Active phone numbers", titleMeta: _jsx(HelpIcon, { text: "Select and edit the surveys that will be used in phone calls.", dark: true }) }, { children: _jsx(PhoneSurveysTable, {}) })), _jsx(SurveyAddModal, {})] }));
};
